import React from 'react';
import Nav from '../Nav/Nav';
import Footer from '../Footer/Footer';
import generalIcon from "../../assets/general.png";
import cSupport from "../../assets/customer-support.png";
import media from "../../assets/media.png";
import vendorEnq from "../../assets/vendor-enq.png";
import advertEnq from "../../assets/advert-enq.png";
import whatsappEnq from "../../assets/whatsapp-enq.png";
import './ContactUs.css';

const contactData = [
  {
    id: 1,
    title: "General Enquiries",
    email: "info@quickplanners.com",
    description: "For any general inquiries, email us at:",
    icon: generalIcon,
  },
  {
    id: 2,
    title: "Advert/Partnerships",
    email: "admin@quickplanners.com",
    description: "For inquiries regarding adverts or partnerships, email us at:",
    icon: advertEnq,
  },
  {
    id: 3,
    title: "PR/Media Requests",
    email: "info@quickplanners.com",
    description: "For media inquiries or interview requests, please our PR team at:",
    icon: media,
  },
  {
    id: 4,
    title: "Vendor Enquiries",
    email: "vendors@quickplanners.com",
    description: "For vendor-related inquiries, email us at:",
    icon: vendorEnq,
  },
  {
    id: 5,
    title: "Customer Support",
    email: "support@quickplanners.com",
    description: "For customer support, email us at:",
    icon: cSupport,
  },
  {
    id: 6,
    title: "WhatsApp",
    link: "https://wa.link/qnt5ga",
    description: "You can also reach out to us via WhatsApp:",
    icon: whatsappEnq,
  }
];

const ContactUs = () => {
  return (
    <div className="contact-page">
      <div className="rectangle"></div>
      <Nav />
      <div className="contact-content">
        <div className="container">
          <h1 className="contact-heading">Contact Us</h1>
          <p className="contact-subtitle">Here are the various ways you can reach us</p>
          
          <div className="contact-grid">
            {contactData.slice(0, 4).map((contact) => (
              <div key={contact.id} className="contact-card">
                <div className="contact-icon" style={{ backgroundColor: contact.bgColor }}>
                  <img src={contact.icon} alt={contact.title} />
                </div>
                <h3 className="contact-card-title">{contact.title}</h3>
                <p className="contact-card-description">{contact.description}</p>
                {contact.email ? (
                  <a href={`mailto:${contact.email}`} className="contact-email">
                    {contact.email}
                  </a>
                ) : (
                  <a href={contact.link} target="_blank" rel="noopener noreferrer" className="contact-whatsapp">
                    {contact.link}
                  </a>
                )}
              </div>
            ))}
          </div>
          
          <div className="contact-bottom-grid">
            {contactData.slice(4).map((contact) => (
              <div key={contact.id} className="contact-card">
                <div className="contact-icon" style={{ backgroundColor: contact.bgColor }}>
                  <img src={contact.icon} alt={contact.title} />
                </div>
                <h3 className="contact-card-title">{contact.title}</h3>
                <p className="contact-card-description">{contact.description}</p>
                {contact.email ? (
                  <a href={`mailto:${contact.email}`} className="contact-email">
                    {contact.email}
                  </a>
                ) : (
                  <a href={contact.link} target="_blank" rel="noopener noreferrer" className="contact-whatsapp">
                    {contact.link}
                  </a>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ContactUs;